import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Pagination, Table } from '@mantine/core';
import PaymentPlanListItem from './PaymentPlanListItem';
import AppFlexbox from '../../common/AppFlexbox';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';

const MAX_PAGE_LENGTH = 10;

const HEADER_STYLE = {
  padding: '8px 12px',
  backgroundColor: 'rgba(56, 56, 56, 0.1)'
};

const AMOUNT_HEADER_STYLE = {
  padding: '8px 12px',
  backgroundColor: 'rgba(56, 56, 56, 0.1)',
  textAlign: 'end'
};

const PaymentPlanList = ({ isLoading, paymentPlans = [] }) => {
  const [pageIndex, setPageIndex] = useState(1);
  const totalPages = Math.ceil(paymentPlans.length / MAX_PAGE_LENGTH);
  const currentPage = Math.min(pageIndex, Math.max(totalPages, 1));

  return (
    <AppStack style={{ gap: 10 }}>
      <AppStack style={{ overflowX: 'auto', gap: 0 }}>
        <Table
          highlightOnHover
          style={{ minWidth: 700 }}
          withRowBorders
          withTableBorder
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th style={HEADER_STYLE}>
                <AppText style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                  Payment plan
                </AppText>
              </Table.Th>
              <Table.Th style={AMOUNT_HEADER_STYLE}>
                <AppText style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                  Plan total
                </AppText>
              </Table.Th>
              <Table.Th style={AMOUNT_HEADER_STYLE}>
                <AppText style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                  Remaining
                </AppText>
              </Table.Th>
              <Table.Th style={HEADER_STYLE}>
                <AppText style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                  Next payment
                </AppText>
              </Table.Th>
              <Table.Th style={HEADER_STYLE}>
                <AppText style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                  Status
                </AppText>
              </Table.Th>
              <Table.Th style={AMOUNT_HEADER_STYLE} />
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {isLoading ? (
              <>
                <PaymentPlanListItem />
                <PaymentPlanListItem />
              </>
            ) : paymentPlans.length === 0 ? (
              <Table.Tr>
                <Table.Td
                  colSpan={6}
                  style={{ padding: 40, textAlign: 'center' }}
                >
                  <AppText style={{ fontSize: 14 }} weight={500}>
                    - You have no payment plans -
                  </AppText>
                </Table.Td>
              </Table.Tr>
            ) : (
              paymentPlans
                .slice(
                  (currentPage - 1) * MAX_PAGE_LENGTH,
                  currentPage * MAX_PAGE_LENGTH
                )
                .map((p) => (
                  <PaymentPlanListItem key={p.pkRegCartPayment} plan={p} />
                ))
            )}
          </Table.Tbody>
        </Table>
      </AppStack>

      {!isLoading && totalPages > 1 && (
        <AppFlexbox style={{ justifyContent: 'center' }}>
          <Pagination
            color="blue"
            onChange={setPageIndex}
            total={totalPages}
            value={currentPage}
          />
        </AppFlexbox>
      )}
    </AppStack>
  );
};

PaymentPlanList.propTypes = {
  isLoading: PropTypes.bool,
  paymentPlans: PropTypes.array
};

export default PaymentPlanList;
